import React from "react";
import "../Company.css";

import {
  FaBuilding,
  FaGlobe,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import OurStory from "../OurStory";
import MissionVision from "../MissionVision";
import CoreValues from "../CoreValues";
import Philosophy from "../Philosophy";

const Company = () => {
  return (
    <>
      <Header />
      <title>VisionVote Technologies | About Us</title>
      <div className="company-page">

        {/* HERO */}

        <section className="company-hero">

          <div className="overlay"></div>

          <div className="company-container hero-content">

            <span className="hero-tag">
              THE COMPANY
            </span>

            <h1>
              Empowering Businesses Through
              <span> Innovation & Technology</span>
            </h1>

            <p>
              VisionVote Technologies Private Limited is a next-generation
              software development and IT consulting company committed to
              building innovative digital solutions that help businesses
              accelerate growth through technology, cloud, AI, and digital
              transformation.
            </p>

          </div>

        </section>

        {/* ABOUT */}

        <section className="about-company">

          <div className="company-container">

            <span className="section-tag">
              ABOUT VISIONVOTE
            </span>

            <h2>
              Building Technology That Creates
              <span> Lasting Business Value</span>
            </h2>

            <p className="intro">
              VisionVote Technologies Private Limited is a modern software
              development and technology consulting company dedicated to
              helping startups, enterprises, and organizations embrace digital
              innovation. We design and develop secure, scalable, and
              future-ready software solutions tailored to solve real-world
              business challenges.

              <br /><br />

              From web and mobile applications to AI-powered platforms,
              enterprise systems, cloud solutions, and digital transformation,
              we combine technical expertise with strategic consulting to
              deliver measurable business outcomes.

              <br /><br />

              At VisionVote Technologies, we believe technology should be more
              than software—it should become a catalyst for innovation,
              operational excellence, and sustainable growth.
            </p>

          </div>

        </section>

        {/* COMPANY PROFILE */}

        <section className="company-profile">

          <div className="company-container">

            <span className="section-tag">
              COMPANY PROFILE
            </span>

            <h2>
              Corporate Information
            </h2>

            <div className="profile-grid">

              <div className="profile-card">
                <FaBuilding />
                <div>
                  <h3>Company Name</h3>
                  <p>VisionVote Technologies Private Limited</p>
                </div>
              </div>

              <div className="profile-card">
                <FaBuilding />
                <div>
                  <h3>Business Type</h3>
                  <p>Private Limited Company</p>
                </div>
              </div>

              <div className="profile-card">
                <FaGlobe />
                <div>
                  <h3>Industry</h3>
                  <p>Software Development & IT Consulting</p>
                </div>
              </div>

              <div className="profile-card">
                <FaMapMarkerAlt />
                <div>
                  <h3>Registered Office</h3>
                  <p>
                    H No-39a, Ramnagar Road, West Tripura, Ramnagar (west Tripura), Sadar
                    <br />
                    Tripura, India, 799002
                  </p>
                </div>
              </div>

              <div className="profile-card">
                <FaEnvelope />
                <div>
                  <h3>Email</h3>
                  <p>research@techvisionvote.in</p>
                </div>
              </div>

              <div className="profile-card">
                <FaPhoneAlt />
                <div>
                  <h3>Phone</h3>
                  <p>03816780017</p>
                </div>
              </div>

              <div className="profile-card">
                <FaGlobe />
                <div>
                  <h3>Website</h3>
                  <p>www.techvisionvote.in</p>
                </div>
              </div>

              <div className="profile-card">
                <FaClock />
                <div>
                  <h3>Business Hours</h3>
                  <p>Monday - Friday<br />9:30 AM - 6:30 PM</p>
                </div>
              </div>

            </div>

          </div>

        </section>

        <OurStory/>
        <MissionVision/>
        <CoreValues/>
        <Philosophy/>

      </div>
      <Footer />
    </>
  );
};

export default Company;